import React from 'react';
import { useConfigContext } from '@m4b-design/config-provider';
import cx from 'classnames';
import Info from '@m4b-design/info';
import './style/radio.less';
var RadioRender = function (props) {
    var _a;
    // const mergedProps = usePropsTranslation(props, ['children', 'placeholder']);
    var globalPrefixCls = useConfigContext().prefixCls;
    var prefixCls = "".concat(globalPrefixCls, "-radio-content");
    var icon = props.icon, tooltipContent = props.tooltipContent, description = props.description, children = props.children;
    var iconLabelClassNames = cx("".concat(prefixCls, "-icon"), (_a = {},
        _a["".concat(prefixCls, "-icon-large")] = !!description,
        _a["".concat(prefixCls, "-icon-default")] = !description,
        _a));
    return (React.createElement("div", { className: cx(prefixCls) },
        icon && React.createElement("div", { className: iconLabelClassNames }, icon),
        React.createElement("div", null,
            children && (tooltipContent ? React.createElement(Info, { content: tooltipContent }, children) : children),
            description && React.createElement("div", { className: "".concat(prefixCls, "-description") }, description))));
};
export default RadioRender;
